import { Outlet } from 'react-router-dom'
import AuthGuard from 'utils/route-quard/AuthGuard'
import { useAuth } from 'context/AuthContext';
import MainLayout from './MainLayout';
import { SettingsContextProvider } from 'context/SettingsContext';

const AuthLayout = () => {
 
    const { auth } = useAuth();
    /** 
     * Якщо немає авторизації, але токент існує - 
     * формуємо компонент "очікування перевірка авторизації"
     * Оскільки перевіряється валідність токена
     * 
     */
    const token = localStorage.getItem('authToken');
    const authMess = (token !== null) && (<span>Authorization...</span>);
    
        
    
     
    return (
        <AuthGuard>  
            {auth.isLogin &&  
            (<>
            <SettingsContextProvider>
                <MainLayout>
                    <Outlet />
                </MainLayout>
            </SettingsContextProvider>
            </>)}
        </AuthGuard>
    ) 
} 

export default AuthLayout;